/* eslint-disable */
import React from 'react'
import { Component } from 'react';
import { connect } from 'react-redux'

import OzComponent from '../lib/OzComponent';
import { isLoggedIn, navTo } from '../utils/util';
import {
} from '../actions';


class Container extends OzComponent {

  static need = [
  ]

  componentDidMount() {
  }

  render() {
    return this.props.children;
  }
}

function mapStateToProps(state) {
  return {
  };
}

function mapDispatchToProps(dispatch) {
  return {
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Container);



/** WEBPACK FOOTER **
 ** ./src/containers/Container.js
 **/